import { useContext } from 'react';
import { useEffect } from 'react';
import Tab from '../components/Tab/Tab';
import AuthContext from '../store/auth-context';

const Experience = () => {
  const context = useContext(AuthContext);

  useEffect(() => {
    context.pathnameHandler(window.location.pathname);
  });

  return (
    <div
      className={`main-screen__content  ${
        context.pathname === '/experience' ? 'show-section' : ''
      }`}
    >
      <div className='main-screen__content-header'>
        <h2>
          <span className='highlight'>&#91;</span>Experience
          <span className='highlight'>&#93;</span>
        </h2>
      </div>
      {context.userDetails && (
        <Tab userDetails={context.userDetails.workExperience} />
      )}
    </div>
  );
};

export default Experience;
